module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row"
  }, [_c('loading', {
    attrs: {
      "loadingText": ("" + (_vm.$t('loading'))),
      "id": "loadMe",
      "loadinSubText": ("" + (_vm.$t('please_wait')))
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('location')))])]), _vm._v(" "), _c('div', {
    staticClass: "box-body no-padding table-responsive"
  }, [_c('form', {
    attrs: {
      "action": ""
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('gmap-autocomplete', {
    staticClass: "introInput form-control",
    attrs: {
      "value": _vm.description
    },
    on: {
      "place_changed": _vm.setPlace
    },
    scopedSlots: _vm._u([{
      key: "input",
      fn: function(slotProps) {
        return [_c('v-text-field', {
          ref: "input",
          attrs: {
            "outlined": "",
            "prepend-inner-icon": "place",
            "placeholder": "Location Of Event"
          },
          on: {
            "listeners": slotProps.listeners,
            "attrs": slotProps.attrs
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('GmapMap', {
    staticStyle: {
      "width": "99%",
      "height": "400px"
    },
    attrs: {
      "id": "map",
      "center": _vm.center,
      "zoom": 15,
      "map-type-id": "terrain"
    },
    on: {
      "click": _vm.getPos
    }
  }, _vm._l((_vm.markers), function(m, index) {
    return _c('GmapMarker', {
      key: index,
      attrs: {
        "position": m.position,
        "clickable": true,
        "draggable": true
      },
      on: {
        "click": function($event) {
          _vm.center = m.position
        }
      }
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.locationName),
      expression: "form.locationName"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "locationName",
      "id": "locationName",
      "placeholder": ("" + (_vm.$t('locationName')))
    },
    domProps: {
      "value": (_vm.form.locationName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "locationName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.district),
      expression: "form.district"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "district",
      "id": "district",
      "placeholder": ("" + (_vm.$t('district')))
    },
    domProps: {
      "value": (_vm.form.district)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "district", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.state),
      expression: "form.state"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "state",
      "id": "state",
      "placeholder": ("" + (_vm.$t('state')))
    },
    domProps: {
      "value": (_vm.form.state)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "state", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.latitude),
      expression: "form.latitude"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "latitude",
      "id": "latitude",
      "placeholder": ("" + (_vm.$t('latitude')))
    },
    domProps: {
      "value": (_vm.form.latitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "latitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.longitude),
      expression: "form.longitude"
    }],
    staticClass: "form-control my-input",
    attrs: {
      "type": "text",
      "name": "longitude",
      "id": "longitude",
      "placeholder": ("" + (_vm.$t('longitude')))
    },
    domProps: {
      "value": (_vm.form.longitude)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "longitude", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "text-center",
    staticStyle: {
      "padding": "20px"
    }
  }, [_c('button', {
    staticClass: "btn btn-success ",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(_vm._s(_vm.$t('submit')))])]), _vm._v(" "), (_vm.error.length > 0) ? _c('div', {
    staticClass: "alert alert-danger padding5"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (_vm.success.length > 0) ? _c('div', {
    staticClass: "alert alert-success padding5"
  }, [_c('i', {
    staticClass: "fa fa-check fa-5x text-success",
    attrs: {
      "aria-hidden": "true"
    }
  })]) : _vm._e()])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-de609e98!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/AddLocation.vue
// module id = 750
// module chunks = 1